import {
  Typography,
  Card,
  CardContent,
  Stack,
  Chip,
  IconButton,
  Checkbox,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function TareaItem({ tarea, leadNombre, hoy, onCompletar, onEliminar }) {
  const vencida = !tarea.completada && !tarea.cancelada && tarea.fechaProgramada < hoy;

  return (
    <Card
      variant="outlined"
      sx={{
        borderLeft: 3,
        borderLeftColor: vencida ? "error.main" : tarea.completada ? "success.main" : "primary.main",
        opacity: tarea.completada ? 0.6 : 1,
      }}
    >
      <CardContent sx={{ py: 1, "&:last-child": { pb: 1 }, display: "flex", alignItems: "center", gap: 1 }}>
        <Checkbox
          checked={tarea.completada}
          onChange={() => !tarea.completada && !tarea.cancelada && onCompletar(tarea.id)}
          disabled={tarea.completada || tarea.cancelada}
          size="small"
        />
        <Box flex={1}>
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{ textDecoration: tarea.completada ? "line-through" : "none" }}
          >
            {tarea.descripcion}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            {tarea.cancelada && <Chip label="Cancelada" size="small" />}
            {leadNombre && (
              <Chip label={leadNombre} size="small" variant="outlined" sx={{ fontSize: 11, height: 20 }} />
            )}
            {tarea.fechaProgramada && (
              <Typography variant="caption" color={vencida ? "error" : "text.secondary"}>
                {vencida ? "⚠ " : ""}{tarea.fechaProgramada}
              </Typography>
            )}
          </Stack>
        </Box>
        {!tarea.completada && !tarea.cancelada && (
          <IconButton size="small" color="error" aria-label="Cancelar seguimiento" title="Cancelar seguimiento" onClick={() => onEliminar(tarea.id)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
        {tarea.completada && <CheckCircleIcon color="success" fontSize="small" />}
      </CardContent>
    </Card>
  );
}
